export const REVENUE_SETUP_STATUS = {
    NOT_STARTED: 'not_started',
    IN_PROGRESS: 'in_progress',
    COMPLETE: 'complete'
};

export const REVENUE_SETUP_LABELS = {
    not_started: 'Not Started',
    in_progress: 'In Progress',
    complete: 'Complete'
};
